export default __webpack_public_path__ + "static/media/misc-books3-768w.4e5a1e5c.png";